import { render, staticRenderFns } from "./firstHome.vue?vue&type=template&id=f4c61d1e&scoped=true&"
import script from "./firstHome.vue?vue&type=script&lang=js&"
export * from "./firstHome.vue?vue&type=script&lang=js&"
import style0 from "./firstHome.vue?vue&type=style&index=0&id=f4c61d1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c61d1e",
  null
  
)

export default component.exports